module.exports = __webpack_public_path__ + "img/login-white-18dp.8c356876.svg";